import { zodContract } from '@farfetched/zod';
import { createQuery } from '../clients';
import { betHistorySchema } from '../types';

export const getLastBetQuery = createQuery({
	request: {
		method: 'GET',
		url: '/rounds/my',
		query: () => ({ limit: 1, page: 1 }),
	},
	response: {
		contract: zodContract(betHistorySchema),
		mapData: ({ result }) => result.rows[0] ?? null,
	},
});
